import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import SiteInfoList from './SiteInfoList';
import { Link } from 'react-router-dom';

let permisionActions = [];

export default class SiteInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.siteInfoState.pageSize,
                pageIndex: this.props.siteInfoState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.SITEINFO);
        this.props.getListSiteInfos(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, siteInfos } = this.props.siteInfoState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'siteInfos'}
                        titleHeader={t('navigation.siteInfos')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.SITEINFO.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <SiteInfoList loading={isFetching}
                                  permisions={permisionActions}
                                  siteinfos={siteInfos}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteSiteInfo}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onChangeLanguage = () => {
        this.props.getListSiteInfos(this.state.filters)
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListSiteInfos(newFilters);
    }

    onDeleteSiteInfo = (item) => {
        this.props.deleteSiteInfoDetail(item, {
            filters: {
                pageSize: this.props.siteInfoState.pageSize,
                pageIndex: this.props.siteInfoState.pageIndex
            }
        });
    }
}

